import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import Icon from 'components/Icon'
import { fetchNotifications, seeNotifications, hideNotifications } from 'store/actions'
import NotificationsPanelItem from './NotificationsPanelItem'
import StyledNotificationsPanel, { NotificationsToggle, NotificationsBody } from './StyledNotificationsPanel'
import { useFlirtPopup } from 'hooks'

const usePanel = ({ seeNotifications, hideNotifications }) => {
  const [showBody, setShowBody] = useState(false)
  const [looking, setLooking] = useState(true)

  useEffect(() => {
    looking ? seeNotifications() : hideNotifications()
  }, [looking])

  return { showBody, looking, setShowBody, setLooking }
}

const NotificationsPanel = ({ items, ...actions }) => {
  const { showBody, setShowBody, setLooking } = usePanel(actions)

  useEffect(() => {
    actions.fetchNotifications()
  }, [])

  useFlirtPopup()

  const renderList = list => (
    <TransitionGroup>
      {list.map((n, i) => (
        <CSSTransition key={i} timeout={500} classNames="item">
          <NotificationsPanelItem notification={n} key={i} />
        </CSSTransition>
      ))}
    </TransitionGroup>
  )

  const onBellClick = () => (showBody ? setShowBody(false) || actions.hideNotifications() : setShowBody(true))

  const recent = items.filter(n => !n.seen)
  const active = showBody || recent?.length > 0
  const hasNotifications = items.length > 0
  const styleProps = { active, hasNotifications }

  return (
    <StyledNotificationsPanel {...styleProps} onMouseLeave={() => setShowBody(false)}>
      <NotificationsToggle onClick={onBellClick} onMouseEnter={() => setShowBody(true)} {...styleProps}>
        {hasNotifications && <span className="notification-count">{items.length}</span>}

        <Icon className="bell" name="bell" family="far" />
      </NotificationsToggle>

      {hasNotifications && (
        <NotificationsBody onMouseEnter={() => setLooking(true)} onMouseLeave={() => setLooking(false)}>
          {renderList(showBody ? [...items].reverse() : recent.reverse().slice(0, 5))}
        </NotificationsBody>
      )}
    </StyledNotificationsPanel>
  )
}

export default connect(s => ({ items: s.notifications.items }), {
  fetchNotifications,
  seeNotifications,
  hideNotifications,
})(NotificationsPanel)
